<template>
<el-dialog :visible.sync="dialogVisible" top="0" width="672px" :before-close="closeModal">
    <div class="row d-flex justify-content-center">
        <div class="col-10">
    <Note class="d-flex mt-5 mb-2 mx-auto"/>
    <h3 class="c-ndarkthree bold text-center">
       Enviar mensagem
    </h3>
    <p class="text-center">Detalhe para o fornecedor caso haja alguma alguma <br>
informação divergente no cadastro.</p>

      <el-input   :class="`${getPrimaryColor} mt-5 w-100`" type="textarea" :rows="4"  placeholder="Escreva uma mensagem..." v-model="review"></el-input>
      </div>
    </div>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <button :class="`btn btn-${getPrimaryColor}`" @click="sendReview">
           Enviar e alterar para revisão
        </button>
    </span>
</el-dialog>
</template>

<script>
import Note from '@/components/icons/Note'
import sendReviewRegister from '@/api/sendReviewRegister'
export default {
    components: {
        Note
    },
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
        cnpjId:{
             required: true,
               default: null
        }
    },
    data() {
        return {
            review: null
        }
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        },
        async sendReview(){
            await sendReviewRegister({review: this.review, cnpjId: this.cnpjId})
            this.$emit('sendReview', false)
            this.$emit('closeModal', false)
            this.$notify({
                title: 'Mensagem enviada com sucesso.',
                message: '',
                type: 'success',
                duration: 3000,
                offset: 100,
                showClose: false
            })
        }
    },
}
</script>

<style>
</style>